import { render } from "./UserProfileView.vue?vue&type=template&id=64a92d02&ts=true"
import script from "./UserProfileView.vue?vue&type=script&lang=ts"
export * from "./UserProfileView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__